import { api } from '../../lib/api-client';
import type { PrintDoc } from './print-types';

const ROUTE: Record<PrintDoc, (uid: string) => string> = {
  invoice: (uid) => `/pos/invoices/${encodeURIComponent(uid)}/print`,
  receipt: (uid) => `/pos/payments/${encodeURIComponent(uid)}/print`,
  'credit-note': (uid) => `/pos/credit-notes/${encodeURIComponent(uid)}/print`,
  refund: (uid) => `/pos/refunds/${encodeURIComponent(uid)}/print`,
};

/** The typed views live with the document components that render them. */
export function fetchPrintView(doc: PrintDoc, uid: string): Promise<unknown> {
  return api<unknown>(ROUTE[doc](uid));
}
